'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { NavItem } from './NavItem';
import { NavItemDrawer } from './NavItemDrawer';
import { StyledDrawerNav } from './base/StyledDrawerNav';
import { StackedNavList } from './base/StackedNavList';
import { StyledNavDrawer } from './base/StyledNavDrawer';
import { StyledNavItemButton } from './base/StyledNavItemButton';
import { navCssClassNames } from './navCssClassNames';
import clsx from 'clsx';
import ClickAwayListener from '@mui/material/ClickAwayListener';
export const NavDrawer = ({ onClose, anchor, items, className, ...props }) => {
    const dummyRootRef = useRef(null);
    const containerFunc = () => dummyRootRef.current;
    const recursiveDrawerProps = {
        anchor,
        onClose,
        elevation: 0,
        container: containerFunc,
        className: clsx(className, navCssClassNames.drawer),
        variant: 'temporary' // [activate Modal Props](https://v5.mui.com/material-ui/api/drawer/#import)
    };
    useEffect(() => {
        if (props.open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    }, [props.open]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { "data-testid": 'dummy-root', ref: dummyRootRef }), _jsx(StyledNavDrawer, { ...props, ...recursiveDrawerProps, disablePortal: true, children: _jsx(ClickAwayListener, { onClickAway: (event) => {
                        onClose?.(event, 'backdropClick');
                    }, children: _jsx(Box, { className: navCssClassNames.drawerBox, display: 'flex', flexDirection: 'column', children: _jsx(StyledDrawerNav, { as: 'nav', className: navCssClassNames.drawerNav, children: _jsx(StackedNavList, { className: navCssClassNames.drawerList, children: items && items.map((item, itemIndex) => {
                                    return item.subNavigationItems?.length ? (_jsx(NavItem, { children: _jsx(NavItemDrawer, { ...item, ...recursiveDrawerProps, level: 2 }) }, `${item.label}-${itemIndex}`)) : (_jsx(NavItem, { children: _jsx(StyledNavItemButton, { ...item, onClick: (clickEvent) => {
                                                item.onClick?.(clickEvent);
                                                onClose?.(clickEvent, 'backdropClick');
                                            }, orientation: 'side', selected: item.selected, children: item.label }) }, `${item.label}-${itemIndex}`));
                                }) }) }) }) }) })] }));
};
